import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { HighlightCategory, Highlight } from '../../services/types/Operation';

interface Props {
  highlightGroups: HighlightCategory[];
  spread?: boolean;
  withoutCategory?: boolean;
}

const Highlights: React.FC<Props> = ({ highlightGroups, spread, withoutCategory }) => {
  const { t } = useTranslation();

  const drawHighlight = (group: string, h: Highlight) => (
    <div key={`${group}${h.name}`} className={`ohighlight${spread ? ' w-100' : ''}`}>
      <div className={`circle ${h.color}`}>
        <div className="inner">{h.value}</div>
      </div>
      <span>{t(h.name)}</span>
    </div>
  );

  const drawGroup = (hg: HighlightCategory, ix: number) => (
    <Fragment key={hg.name}>
      {ix === 0 ? null : <div className="v-line" />}
      <div className={`category${spread ? ' w-100 ml-0' : ''}`}>
        <span className="label">{!withoutCategory && t(hg.name)}</span>
        {hg.highlights.map((h) => drawHighlight(hg.name, h))}
      </div>
    </Fragment>
  );

  return (
    <div className={`content op-highlights${spread ? ' w-100' : ''}`}>
      {highlightGroups.map((hg, ix) => drawGroup(hg, ix))}
    </div>
  );
};

export default Highlights;
